import { useEffect } from 'react';

import { useStepperContext } from 'lib/context/StepperContext/StepperContext';

import withWizardStep from '../../../OnboardingWizard/components/withWizardStep';

const StepPlaceholder = withWizardStep(() => {
  const { goNext, addFooterActions, activeSubstep, setHeaderButtonProps } = useStepperContext();
  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Skip for now',
        onClick: goNext,
        outlined: true
      }
    ]);
  }, [activeSubstep?.code]);
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4">
      <div className="w-full max-w-[70%] text-center text-neutral-500">
        This step is not yet configured.
      </div>
      <div className="w-full max-w-[70%] text-center text-neutral-500">
        please configure the `component` or `fallbackComponent` for this step in the
        `componentStepsConfig` prop of the Stepper.
      </div>
    </div>
  );
});

export default StepPlaceholder;
